import React from 'react';
import { HexColorPicker, HexColorInput } from "react-colorful";
import reactCSS from 'reactcss';

export const ColorPicker = ({ onChange, name, color }) => {
    const styles = reactCSS({
        'default': {
            card: {
                width: '220px',
                background: 'white',
                boxShadow: 'rgb(0 0 0 / 25%) 0px 0px 0px 1px, rgb(0 0 0 / 15%) 0px 8px 16px',
                borderRadius: '0.25rem',
                position: 'relative',
            },
            bottom: {
                position: 'relative',
                padding: '10px',
            },
            saturationHue: {
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto .5rem',
                width: '230px',
                position: 'relative',
            },
            inputWrap: {
                position: 'relative',
            },
            label: {
                float: 'left',
                fontSize: '20px',
                marginRight: '.5rem',
            }
        }
    });

    return (
        <div style={ styles.card } >
            <div style={ styles.bottom }>
                <div style={ styles.saturationHue }>
                    <HexColorPicker color={color} onChange={e => onChange(e, name)} />
                </div>
                <div style={ styles.inputWrap }>
                    <span style={ styles.label }>Hex</span>
                    <HexColorInput color={color} prefixed={true} onChange={e => onChange(e, name)} />
                </div>
            </div>
        </div>
    );
};

export default ColorPicker;